export const IPVControllerFactory = ({
  ipvService,
}: {
  ipvService: IIPVService;
}) => {
  const getIPVNotesList: IGetIPVNotesList = async ({
    clinicId,
    startDate,
    endDate,
  }) => {
    const response = await ipvService.getIPVNotesListService({
      clinicId,
      status: 1,
      startDate,
      endDate,
    });

    return response;
  };

  const addIPVNotesAck: IAddIPVNotesAck = async ({ clinicId, note_id }) => {
    const response = await ipvService.addIPVNotesAckService({
      clinic_id: clinicId,
      note_id: note_id,
    });
    return response;
  };

  return {
    getIPVNotesList,
    addIPVNotesAck,
  };
};
